import { MouseEventHandler, ReactNode } from "react";
import styled from "styled-components";

import { InsurancePlan } from "pwapi";

const Item = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 0.2em 0.5em;
  background: ${({ $isSelected }) =>
    $isSelected ? "var(--purple50)" : "var(--white)"};
  color: ${({ $isSelected }) => ($isSelected ? "var(--white)" : "inherit")};
`;

const ItemContents = styled.div`
  display: flex;
  align-items: center;
`;

const Index = styled.code<{ $isSelected?: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? "var(--white)" : "#999")};
  margin-right: 0.5em;
  font-size: 0.9em;
  line-height: 1.1;
`;

const MainText = styled.p`
  margin: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SuffixText = styled.span`
  font-size: 0.95em;

  code {
    font-family: monospace;
    font-size: 1em;
    color: var(--steel);
  }
`;

const DescriptionText = styled.p<{ $isSelected?: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? "var(--white)" : "#666")};
  font-weight: normal;
  margin: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
type ListItemProps = {
  index?: string | number;
  title?: string | null;
  isSelected?: boolean;
  handleOnClick?: MouseEventHandler<HTMLDivElement>;
  info: {
    main: string;
    mainSuffix?: string | ReactNode;
    description?: string | ReactNode;
  };
};

export const ListItem = (props: ListItemProps) => {
  const { index, info, title, isSelected, handleOnClick } = props;

  return (
    <Item
      title={title || undefined}
      onClick={handleOnClick}
      $isSelected={isSelected}
    >
      <ItemContents>
        {index ? <Index $isSelected={isSelected}>{index}</Index> : <></>}
        <MainText>
          <strong>{info.main}</strong>
          <SuffixText>{info.mainSuffix}</SuffixText>
        </MainText>
      </ItemContents>
      <DescriptionText $isSelected={isSelected}>
        {info.description}
      </DescriptionText>
    </Item>
  );
};

export const InsuranceListItem = ({
  object: insurance,
  isSelected,
  handleOnClick,
}: {
  object: InsurancePlan;
  isSelected?: boolean;
  handleOnClick?: Function;
}) => {
  const { payer_location, payer_name } = insurance;

  return (
    <ListItem
      handleOnClick={handleOnClick && (() => handleOnClick(insurance))}
      title={payer_name}
      isSelected={isSelected}
      info={{
        main: payer_name || "",
        description: (
          <>
            {payer_location && (
              <>
                {payer_location.street}, {payer_location.city},{" "}
                {payer_location.state} {payer_location.zipcode}
              </>
            )}
          </>
        ),
      }}
    />
  );
};
